<template>
  <v-app dark id="app">
    <component :is="layout">
      <NotificationContainer />
      <notifications group="main" position="top center" :speed="500" />
      <transition name="slide-fade" mode="out-in">
        <router-view class="page" :key="$route.fullPath" />
        <!--reloads components when URL changhes, including parameters)-->
      </transition>
    </component>
  </v-app>
</template>

<script>
import NotificationContainer from '@/components/ui/NotificationContainer.vue'

const default_layout = 'backClient'

export default {
    metaInfo: {
      title: '',
      titleTemplate: '%s | expar',
      htmlAttrs: {
        lang: 'en'
      },
      meta: [
        { charset: 'utf-8' },
		{ name: 'author', content: 'linking map' },
        { name: 'description', content: 'Platform designed as a multi-vendor on-demand e-commerce web application' },
		{ name: 'keywords', content: 'e-commerce, platform, butique, turism' },
        { name: 'viewport', content: 'width=device-width, initial-scale=1' }
      ]
  },
  computed: {
    layout() {
      return this.$route.meta.requiresAuth || this.$route.meta.layout
        ? (this.$route.meta.layout || default_layout) + '-layout'
        : ''
    },
  },
  components: {
    NotificationContainer,
  },
}
</script>

<style lang="scss">
@import './assets/styles/global.scss';
html {
  scroll-behavior: smooth;
}
</style>
